import React from "react"

import { URL, WOW_MONEY_MAX_PRICE } from "live/constants"

import Roller from "./Roller"

interface Props {
  username?: string
}

/** 이번 달 적립 한도를 모두 채운 상태. 완료 안내와 룰렛 이벤트 홍보 문구를 롤링으로 번갈아 보여준다 */
const Completed = ({ username }: Props) => (
  <Roller>
    <li className="current">
      <p className="wmComplete">
        <strong className="wmName">{username}</strong>님 이번 달 와우머니 총{" "}
        <strong className="wmPoint">
          {WOW_MONEY_MAX_PRICE.toLocaleString()}
        </strong>
        원 적립 성공! 다음 달도 꼭 도전하세요!
      </p>
    </li>
    <li className="wmRow next">
      <p className="wmLoginTxt">
        <strong className="wmName">{username}</strong>님{" "}
        <strong className="wmPoint">매일매일 100% 당첨 룰렛 이벤트</strong>도
        참여해보세요!
      </p>
      <a
        href={URL.ROULETTE_EVENT}
        target="_blank"
        rel="noopener noreferrer"
        className="wmLoginBtn"
        title="룰렛이벤트 바로가기"
      >
        바로가기 <span className="wmLoginArrow">&gt;</span>
      </a>
    </li>
  </Roller>
)

export default Completed
